<template>
  <!-- 失业率 -->
  <el-form ref="form" :model="form" label-position="top">
    <div class="table_container">
      <table>
        <tbody align="center">
          <tr>
            <th width="175px"></th>
            <th colspan="12">{{ `${queryParams.years}年` }}</th>
          </tr>
          <tr>
            <th>月度</th>
            <th v-for="(item, index) in monthList" :key="index">
              {{ item.month }}
            </th>
          </tr>
          <tr>
            <th>失业率(%)</th>
            <td
              v-for="(item, index) in monthList"
              :key="index"
              @click="handleColumn(item.unemploymentRateField)"
            >
              <el-input
                v-if="editField === item.unemploymentRateField"
                id="focusRef"
                v-model="form.unemploymenRate[item.unemploymentRateField]"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              ></el-input>
              <span v-else>
                {{ form.unemploymenRate[item.unemploymentRateField] }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="form_container">
      <!-- 本月经济形势变化情况(或经济热点事件) -->
      <el-form-item
        label="本月经济形势变化情况(或经济热点事件)"
        prop="economicChanges"
      >
        <el-input
          v-model="form.economicChangesObject.economicChanges"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { addOrUpdateUnemploymentRateApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      form: this.getForm(),
      editField: "", // 编辑单元格
      monthList: [
        {
          month: "1月",
          unemploymentRateField: "oneRate"
        },
        {
          month: "2月",
          unemploymentRateField: "twoRate"
        },
        {
          month: "3月",
          unemploymentRateField: "threeRate"
        },
        {
          month: "4月",
          unemploymentRateField: "fourRate"
        },
        {
          month: "5月",
          unemploymentRateField: "fiveRate"
        },
        {
          month: "6月",
          unemploymentRateField: "sixRate"
        },
        {
          month: "7月",
          unemploymentRateField: "sevenRate"
        },
        {
          month: "8月",
          unemploymentRateField: "eightRate"
        },
        {
          month: "9月",
          unemploymentRateField: "nineRate"
        },
        {
          month: "10月",
          unemploymentRateField: "tenRate"
        },
        {
          month: "11月",
          unemploymentRateField: "elevenRate"
        },
        {
          month: "12月",
          unemploymentRateField: "twelveRate"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.queryParams = { ...queryParams };
      this.form = this.getForm(
        data.unemploymenRate || {},
        data.economicChangesObject || {}
      );
    },
    // 获取表单数据
    getForm(unemploymenRate = {}, economicChangesObject = {}) {
      return {
        unemploymenRate: {
          id: unemploymenRate.id || "",
          oneRate: unemploymenRate.oneRate ?? undefined,
          twoRate: unemploymenRate.twoRate ?? undefined,
          threeRate: unemploymenRate.threeRate ?? undefined,
          fourRate: unemploymenRate.fourRate ?? undefined,
          fiveRate: unemploymenRate.fiveRate ?? undefined,
          sixRate: unemploymenRate.sixRate ?? undefined,
          sevenRate: unemploymenRate.sevenRate ?? undefined,
          eightRate: unemploymenRate.eightRate ?? undefined,
          nineRate: unemploymenRate.nineRate ?? undefined,
          tenRate: unemploymenRate.tenRate ?? undefined,
          elevenRate: unemploymenRate.elevenRate ?? undefined,
          twelveRate: unemploymenRate.twelveRate ?? undefined
        },
        economicChangesObject: {
          id: economicChangesObject.id || "",
          economicChanges: economicChangesObject.economicChanges || ""
        }
      };
    },
    // 点击单元格编辑
    handleColumn(field) {
      this.editField = field;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // 保存
    async handleSave(callBack) {
      try {
        let submitData = JSON.parse(JSON.stringify(this.form));
        submitData.unemploymenRate = {
          ...this.queryParams,
          ...submitData.unemploymenRate
        };
        submitData.economicChangesObject = {
          ...this.queryParams,
          ...submitData.economicChangesObject
        };
        const res = await addOrUpdateUnemploymentRateApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.form.unemploymenRate.id = res.data.unemploymenRate.id;
          this.form.economicChangesObject.id =
            res.data.economicChangesObject.id;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 0 18px 0 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
.form_container {
  margin-top: 34px;
  padding: 0 18px 0 50px;
  ::v-deep {
    .el-input {
      width: 200px;
    }
  }
}
</style>
